import { render, staticRenderFns } from "./UniqueApproach.vue?vue&type=template&id=00a7bc9e"
import script from "./UniqueApproach.vue?vue&type=script&lang=js"
export * from "./UniqueApproach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports